import { useEffect, useState, useRef } from "react"
import React from "react";

import Container from "./InsureElevator_css"
import dayjs from "dayjs"
import JDate from "jalali-date"

export default function InsureElevator({ data }) {
      const [showMore1, setShowMore1] = useState(false)
      const [showMore2, setShowMore2] = useState(false)
      const [showMore3, setShowMore3] = useState(false)

      const details = JSON.parse( data.data[0].request_detail_json)
      console.log(details.elevator_yearofcons_name);

      var arrPrice = []
      try {
            arrPrice = JSON.parse(data.data[0].jsonpricing_text)
            if (arrPrice.instalment_conditions) {
                  var cash = arrPrice.instalment_conditions.filter((c) => c.instalment_conditions_mode_id === "0")
                  var check = arrPrice.instalment_conditions.filter(
                        (c) => c.instalment_conditions_mode_id === "1" || c.instalment_conditions_mode_id === "3"
                  )
            }
      } catch (e) {
            console.log(e)
      }

      let al = arrPrice.instalment_conditions
      if (arrPrice.instalment_conditions) {
            al.sort(function (a, b) {
                  // console.log("b: ", b)
                  return Number(a.instalment_conditions_date) - Number(b.instalment_conditions_date)
            })
      }

      var date = dayjs(data.data[0].request_thirdparty_last_date_sart)
      var startDate = new JDate(new Date(date.valueOf())).format("YYYY/MM/DD ")

      var date2 = dayjs(data.data[0].request_thirdparty_last_date_end)
      var endDate = new JDate(new Date(date2.valueOf())).format("YYYY/MM/DD ")

      var active_star =
            parseInt(arrPrice.company_customer_satisfaction) +
            parseInt(arrPrice.company_levelof_prosperity) +
            parseInt(arrPrice.company_timeanswer_complaints)

      active_star = Math.ceil(active_star / 3 / 2)
      var deactive_star = 5 - active_star

      const Stars = () => {
            var stars = []
            for (var i = 0; i < active_star; i++) {
                  stars.push(<img src="/imagess/star.png" key={i + deactive_star} alt="star icon" />)
            }
            return <>{stars}</>
      }

      const Stars_ = () => {
            var dstars = []
            for (var i = 0; i < deactive_star; i++) {
                  dstars.push(<img src="/imagess/star_.png" key={i} alt="star icon" />)
            }
            return <>{dstars}</>
      }

      function formatPrice(value) {
            return String(value).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
      }

      const handleClick = (id) => {
            if (id === 1) {
                  setShowMore1(!showMore1)
            } else if (id === 2) {
                  setShowMore2(!showMore2)
            } else if (id === 3) {
                  setShowMore3(!showMore3)
            }
      }

      return (
            <Container>
                  <div className="root">
                        <div className="header-text-new">اطلاعات سفارش</div>
                        <div className="title">
                              <span className="title-text">بیمه مسولیت آسانسور</span>
                        </div>

                        <div className="body">
                              <div className="right">
                                    <div className="items" style={{ maxHeight: showMore1 ? 2000 : 100 }}>
                                          <div className="item">
                                                <div className="item-right"> کاربری ساختمان</div>
                                                <div className="item-center">&nbsp;</div>
                                                <div className="item-left"> {details.elevator_uses_name}</div>
                                          </div>
                                          <div className="item">
                                                <div className="item-right"> نوع آسانسور</div>
                                                <div className="item-center">&nbsp;</div>
                                                <div className="item-left"> {details.elevator_kind_name}</div>
                                          </div>
                                          <div className="item">
                                                <div className="item-right"> نوع درب آسانسور</div>
                                                <div className="item-center">&nbsp;</div>
                                                <div className="item-left">{details.elevator_kinddoor_name}</div>
                                          </div>
                                          <div className="item">
                                                <div className="item-right"> ظرفیت</div>
                                                <div className="item-center">&nbsp;</div>
                                                <div className="item-left">{details.elevator_capacity_name} </div>
                                          </div>
                                          <div className="item">
                                                <div className="item-right"> سال ساخت </div>
                                                <div className="item-center">&nbsp;</div>
                                                <div className="item-left">{details.elevator_yearofcons_name} </div>
                                          </div>
                                    </div>

                                    <div className="show-more" onClick={() => handleClick(1)}>
                                          <img alt="arrow icon" src={showMore1 ? "/imagess/ArrowUp Icon.svg" : "/imagess/ArrowDown Icon.svg"} />
                                    </div>
                              </div>
                              {/*<div className="center">*/}
                              {/*      <div className="items" style={{ maxHeight: showMore2 ? 2000 : 100 }}>*/}
                              {/*            <div className="item">*/}
                              {/*                  <div className="item-right">پوشش بیمه نامه</div>*/}
                              {/*                  <div className="item-center">&nbsp;</div>*/}
                              {/*                  <div className="item-left">{formatPrice(data.data[0].elevator_coverage_desc)} ریال </div>*/}
                              {/*            </div>*/}
                              {/*      </div>*/}

                              {/*      <div className="show-more" onClick={() => handleClick(2)}>*/}
                              {/*            <img alt="arrow icon" src={showMore2 ? "/imagess/ArrowUp Icon.svg" : "/imagess/ArrowDown Icon.svg"} />*/}
                              {/*      </div>*/}
                              {/*</div>*/}
                              <div className="left">
                                    <div className="items" style={{ maxHeight: showMore3 ? 2000 : 100 }}>
                                          <div className="item">
                                                <div className="item-right">نام بیمه</div>
                                                <div className="item-center">&nbsp;</div>
                                                <div className="item-left">
                                                      {arrPrice.company_name}{" "}
                                                      <img
                                                            src={arrPrice.company_logo_url}
                                                            alt="لوگو بیمه"
                                                            style={{
                                                                  width: "30px",
                                                                  height: "30px",
                                                                  marginRight: "5px",
                                                            }}
                                                      />
                                                </div>
                                          </div>
                                          <div className="item">
                                                <div className="item-right">امتیاز بیمه</div>
                                                <div className="item-center">&nbsp;</div>
                                                <div className="item-left">
                                                      <div className="bottom">
                                                            <Stars />
                                                            <Stars_ />
                                                      </div>
                                                </div>
                                          </div>
                                          <div className="item">
                                                <div className="item-right">مبلغ بیمه </div>
                                                <div className="item-center">&nbsp;</div>
                                                <div className="item-left">{formatPrice(arrPrice.price)} ریال</div>
                                          </div>
                                          <div className="item">
                                                <div className="item-right">درصد تخفیف</div>
                                                <div className="item-center">&nbsp;</div>
                                                <div className="item-left">
                                                      {arrPrice.managdiscount_amount ? `${arrPrice.managdiscount_amount} درصد` : "ندارد"}
                                                </div>
                                          </div>
                                          {/*<div className="item">*/}
                                          {/*      <div className="item-right">توضیحات بیمه نامه </div>*/}
                                          {/*      <div className="item-center">&nbsp;</div>*/}
                                          {/*      <div className="item-left">{arrPrice.tip}</div>*/}
                                          {/*</div>*/}

                                          <div className="item">
                                                <div className="item-right">امکان خرید اقساطی</div>
                                                <div className="item-center">&nbsp;</div>
                                                <div className="item-left">{arrPrice.instalment_conditions ? "بله" : "خیر"}</div>
                                          </div>

                                          {/*{arrPrice.instalment_conditions ? (*/}
                                          {/*    arrPrice.instalment_conditions.map((c) => (*/}
                                          {/*      <div*/}
                                          {/*         className='item'*/}
                                          {/*         key={c.instalment_conditions_id}>*/}
                                          {/*         <div className='item-right'>مبلغ {c.instalment_mode_mode_name}</div>*/}
                                          {/*         <div className='item-center'>&nbsp;</div>*/}
                                          {/*         <div className='item-left'>*/}
                                          {/*            {formatPrice(c.instalment_conditions_amount)}{" "}*/}
                                          {/*            ریال*/}
                                          {/*         </div>*/}
                                          {/*      </div>*/}
                                          {/*   ))*/}
                                          {/*) : (*/}
                                          {/*   <></>*/}
                                          {/*)}*/}
                                          {arrPrice.instalment_conditions ? (
                                                al.map((c, index) => (
                                                      <div className="item" key={c.instalment_conditions_id}>
                                                            <div className="item-right">
                                                                  {" "}
                                                                  {c.instalment_conditions_date === "0"
                                                                        ? "اولین قسط"
                                                                        : ` ${c.instalment_conditions_date}ماه بعد`}{" "}
                                                                  {c.instalment_mode_mode_name}
                                                            </div>
                                                            <div className="item-center">&nbsp;</div>
                                                            <div className="item-left"> {formatPrice(c.instalment_conditions_amount)} ریال</div>
                                                      </div>
                                                ))
                                          ) : (
                                                <></>
                                          )}

                                          {arrPrice.organ_contract_id ? (
                                                <div className="item">
                                                      <div className="item-right"> نام سازمان</div>
                                                      <div className="item-center">&nbsp;</div>
                                                      <div className="item-left">
                                                            {arrPrice.organ_name}
                                                            <img
                                                                  style={{
                                                                        width: "30px",
                                                                        height: "30px",
                                                                        marginRight: "8px",
                                                                  }}
                                                                  src={arrPrice.organ_logo}
                                                                  alt="لوگوی سازمان"
                                                            />
                                                      </div>
                                                </div>
                                          ) : (
                                                <></>
                                          )}
                                    </div>
                                    <div className="show-more" onClick={() => handleClick(3)}>
                                          <img alt="arrow icon" src={showMore3 ? "/imagess/ArrowUp Icon.svg" : "/imagess/ArrowDown Icon.svg"} />
                                    </div>
                              </div>
                        </div>
                  </div>
            </Container>
      )
}
